import { SitecorePageProps } from 'lib/page-props';
import { GetStaticPropsContext, GetServerSidePropsContext } from 'next';
import { Plugin } from '..';
import axios from 'axios';

export const FUND_DETAILS_TEMPLATE_IDS = [
  '5827425c-1b42-46d1-9f13-11387a5bd4b3', // Automation vector
  '543d5f77-8ad4-4326-9e23-84804031cb3c', // Investments vector
  '023EE573-91D8-46DC-A139-7A3EB4157AAA', // Adviser vector
  'E3590AD7-64A8-4980-A419-C4F1F926F9FC', // Global vector
];
import { apiHost } from 'api/apiHost';

class FundDetailsPagePropsPlugin implements Plugin {
  order: number = 11;
  async exec(
    props: SitecorePageProps,
    context: GetStaticPropsContext | GetServerSidePropsContext
  ): Promise<SitecorePageProps> {
    const templateId = props.layoutData.sitecore.route?.templateId ?? '';

    if (!FUND_DETAILS_TEMPLATE_IDS.includes(templateId)) return props;

    const isinCode = context.params.path?.at(-1)?.split('-').at(-1);
    const {
      language,
      fundsConfiguration: {
        countryInvestors: { countryCode, investorType, jurisdiction, literatureAuthorization },
      },
    } = props.layoutData.sitecore.context;
    const fundDetailsPayload = {
      CountryInvestors: {
        CountryCode: countryCode,
        InvestorType: investorType,
        Jurisdiction: jurisdiction,
        LiteratureAuthorization: literatureAuthorization,
      },
      language: language,
      isin: isinCode,
    };

    try {
      props.pageData.fundDetailsData = {
        data: null,
        error: false,
      };
      const { data } = await axios.post(`${apiHost}/api/funds/funddetails`, fundDetailsPayload);
      if (data) {
        props.layoutData.sitecore.context.metaTitle = data.name;

        props.pageData.pageTitle = data.name;
        props.pageData.fundDetailsData.data = { ...data, isinCode };
      }
    } catch (e) {
      console.log('error during requesting fund details page', e);
      props.pageData.fundDetailsData = {
        error: true,
        data: {},
      };
    }

    return props;
  }
}

export const fundDetailsPlugin = new FundDetailsPagePropsPlugin();
